import { create } from 'zustand'

export type PendingPdfShare = {
  bytes: Uint8Array
  filename: string
  title: string
  /** Documento clínico persistido — habilita «Compartilhar link» no sheet. */
  documentId?: string
}

interface PdfShareStoreState {
  pending: PendingPdfShare | null
  present: (pending: PendingPdfShare) => void
  dismiss: () => void
}

export const usePdfShareStore = create<PdfShareStoreState>((set) => ({
  pending: null,
  present: (pending) =>
    set({
      pending: {
        bytes: pending.bytes.slice(),
        filename: pending.filename,
        title: pending.title,
        documentId: pending.documentId,
      },
    }),
  dismiss: () => set({ pending: null }),
}))
